<template>
  <slot />
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false });
</script>
